import axiosPrivateInstance from './AxiosPrivateInstance';

export const getDashboardData = async () => {
    try {
        const res = await axiosPrivateInstance.get('/dashboard/');
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};

export const getCustomersList = async (page = 1, pageitems = 10) => {
    try {
        const res = await axiosPrivateInstance.get(
            `/restaurant-customers/?page=${page}&pageitems=${pageitems}`
        );
        return res.data; // Return the full response to access pagination metadata
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const filterCustomersList = async (year, page = 1, pageitems = 10) => {
    try {
        const res = await axiosPrivateInstance.get(
            `/restaurant-customers/?page=${page}&pageitems=${pageitems}&year=${year}`
        );
        return res.data; // Return the full response to access pagination metadata
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const viewProfile = async () => {
    try {
        const res = await axiosPrivateInstance.get('/restaurant-user-profile/');
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};

export const getNotificationToken = async () => {
    try {
        const res = await axiosPrivateInstance.get('/restaurant-notification/');
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};

export const seenNotification = async notifid => {
    try {
        const fd = new FormData();
        fd.append('notifid', notifid); // ensure string

        const res = await axiosPrivateInstance.patch(
            '/restaurant-notification/',
            fd
        );

        return res.data?.data;
    } catch (error) {
        console.error(
            'seenNotification error:',
            error?.response?.data || error
        );
    }
};
